import React from 'react'
import { Routes, Route } from 'react-router-dom'

import Auth from '../pages/Auth.page'
import AdminAuth from '../pages/AuthAdmin.page'
import PartnerAuth from '../pages/AuthPartner.page'



const notAuthRoutes = (
    <Routes>
        <Route path="/" element={<Auth />} exact />
        <Route path="/admin" element={<AdminAuth />} exact />
        <Route path="/merchant" element={<PartnerAuth />} exact />
        <Route path="*" element={<Auth />} exact  />
    </Routes>
)

export default notAuthRoutes
